module.exports = __webpack_public_path__ + "img/process.72a24844.png";